import React, { useState } from 'react';
import styled, { css, createGlobalStyle } from 'styled-components';

import Close from './close';

const GlobalStyle = createGlobalStyle`
  body {
    ${(props) => props.open && css`
      max-width: 100%;
      overflow: hidden;
    `}
  }
`;

const Modal = ({ children, className, show }) => {
  const [open, setOpen] = useState(show);
  if (!open) {
    return null;
  }
  return (
    <div className={className}>
      <Panel>
        <GlobalStyle open={open} />
        <Close setOpen={setOpen} />
        {children}
      </Panel>
    </div>
  );
};

const Panel = styled.article`
  position: absolute;
  background-color: white;
  top: 1rem;
  left: 1rem;
  right: 1rem;
  border-radius: ${(props) => props.theme.borderRadius};
  padding: 1rem;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    width: 35rem;
    left: auto;
    right: auto;
  }
`;

export default styled(Modal)`
  overflow-x: hidden;
  overflow-y: auto;
  opacity: 1;
  position: fixed;
  background-color: rgba(0, 0, 0, 50%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  color: ${({ theme }) => theme.fontColor};
`;
